<template>
  <div class="main">
    <b-card-body class="card-body">
      <b-card>
        <div class="text-title">
          {{ $t('configurar-horario-turno-trabalho') }}
        </div>
        <hr>
        <b-form>
          <b-form-row class="row-card title mt-3">
            <b-col
              class="col-phone-1" 
              sm="3" 
              lg="2"
            >
            <span>Descrição</span>
            </b-col>
            <b-col 
              class="col-phone-1"
              sm="3"
              lg="4"
            >
              <span>{{ $t('horario-inicial') }}</span>
            </b-col>
            <b-col 
              class="col-phone-1" 
              sm="3" 
              lg="4"
            >
              <span>{{ $t('horario-final') }}</span>
            </b-col>
            <b-col 
              class="col-phone-2" 
              sm="3" 
              lg="2"
            >
              <span>{{ $t('inicio-do-dia') }}</span>
            </b-col>
          </b-form-row>
          <span v-if="workshift.length > 0">
            <b-row 
              v-for="shift in workshift" 
              :key="shift.id" 
              class="row-card"
            >
              <b-col 
                class="col-phone-1" 
                sm="3"
                lg="2"
              >
                <b-form-input
                  id="workshift-start-1"
                  v-model="shift.description"
                  class="input-pentagro"
                  type="text"
                  name="validateGdi"
                  :placeholder="$t('turno')"
                />
              </b-col>

              <b-col 
                class="col-phone-1" 
                sm="3" 
                lg="4"
              >
                <b-form-group>
                  <b-form-input
                    id="workshift-end-1"
                    v-model="shift.start"
                    v-validate="{
                      required: true,
                    }"
                    :state="validateState('validatePgdi')"
                    name="validatePgdi"
                    class="input-pentagro"
                    type="text"
                    :data-vv-as="$t('horario-inicial')"
                    placeholder="HH:MM:SS"
                    @change="() => shift.start = checkHourFormat(shift.start)"
                  />
                  <b-form-invalid-feedback id="validatePgdi-feedback">{{
                    veeErrors.first("validatePgdi")
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col 
                class="col-phone-1" 
                sm="3" 
                lg="4"
              >
                <b-form-group v-if="user">
                  <b-form-input
                    id="workshift-start-1"
                    v-model="shift.end"
                    :disabled="true"
                    class="input-pentagro"
                    type="text"
                    placeholder="HH:MM:SS"
                  />
                </b-form-group>
              </b-col>

              <b-col 
                sm="3" 
                lg="2" 
                class="radio-reference col-phone-2"
              >
                <b-form-radio 
                  v-model="shift.reference"
                  :value="1"
                  name="some-radios"
                  @change="setReference(shift)"
                />
              </b-col>
            </b-row>
          
          </span>
          <span v-else>
            <p class="loading">{{ $t('carregando-configuracoes') }}</p>
          </span>
          <hr>
          <div class="text-title-2">
            {{ $t('configurar-horario-boletim') }}
          </div>
          <hr>
          <span>
              <b-form-row class="row-card title mt-3">
                <b-col
                  class="col-phone-1" 
                  sm="3" 
                  lg="2"
                >
                  <span>Descrição</span>
                </b-col>
                <b-col 
                  class="col-phone-1"
                  sm="3"
                  lg="4"
                >
                  <span>{{ $t('horario-inicial') }}</span>
                </b-col>
                <b-col 
                  class="col-phone-1" 
                  sm="3" 
                  lg="4"
                >
                  <span>{{ $t('horario-final') }}</span>
                </b-col>
              </b-form-row>
          </span>
          <span v-if="workshiftDay.length > 0">
            <b-row 
              v-for="shift in workshiftDay" 
              :key="shift.id" 
              class="row-card"
            >
              <b-col 
                class="col-phone-1" 
                sm="3"
                lg="2"
              >
                <b-form-input
                  id="workshift-start-1"
                  v-model="shift.description"
                  class="input-pentagro"
                  type="text"
                  name="validateGdi"
                  :placeholder="$t('turno')"
                />
              </b-col>

              <b-col 
                class="col-phone-1" 
                sm="3" 
                lg="4"
              >
                <b-form-group>
                  <b-form-input
                    id="workshift-end-1"
                    v-model="shift.start"
                    v-validate="{
                      required: true,
                    }"
                    :state="validateState('validatePgdi')"
                    name="validatePgdi"
                    class="input-pentagro"
                    type="text"
                    :data-vv-as="$t('horario-inicial')"
                    placeholder="HH:MM:SS"
                    @change="() => shift.start = checkHourFormat(shift.start)"
                  />
                  <b-form-invalid-feedback id="validatePgdi-feedback">{{
                    veeErrors.first("validatePgdi")
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col 
                class="col-phone-1" 
                sm="3" 
                lg="4"
              >
                <b-form-group v-if="user">
                  <b-form-input
                    id="workshift-start-1"
                    v-model="shift.end"
                    :disabled="true"
                    class="input-pentagro"
                    type="text"
                    placeholder="HH:MM:SS"
                  />
                </b-form-group>
              </b-col>

              <b-col 
                sm="3" 
                lg="2" 
                class="radio-reference col-phone-2"
              >
              </b-col>
            </b-row>
          </span>
          <span v-else>
            <p class="loading">{{ $t('carregando-configuracoes') }}</p>
          </span>
          <hr>
          <b-row class="groupBtn mt-2">
            <div>
              <img
                src="@/assets/salvar.png"
                :alt="$t('salvar')"
                style="margin-left: 30px;"
                :title="$t('salvar')"
                @click="save"
              >
              <img
                src="@/assets/atualizar.png"
                style="margin-left: 30px;"
                :title="$t('limpar')"
                :alt="$t('limpar')"
                @click="resetForm"
              >
              <img
                id="closeModalPassword"
                class="float-right"
                src="@/assets/sair.png"
                style="margin-left: 30px;"
                :title="$t('sair')"
                :alt="$t('sair')"
                @click="$bvModal.hide('modalWorkShift')"
              >
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import { FiltersMixin } from "../mixins/filtersMixin"
import WorkShift from "./workshift"
import axios from "axios";

export default {
  name: "WorkShift",
  computed: mapState(["user"]),
  // eslint-disable-next-line vue/order-in-components
  mixins: [ FiltersMixin ],
  // eslint-disable-next-line vue/order-in-components
  data: function() {
    return {
      workshift: new Array(),
      backupWorkshift: new Array(),
      workshiftDay: new Array(),
      typeSetShift : {
        all: 'all',
        day: 'day',
        shift: 'shift'
      }
    };
  },
  
  created() {
    this.$validator.localize("pt_BR");
    this.load()
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    checkHourFormat(time){
      if(!time.includes(":") && time.length == 6){
        time = `${time.substring(0,2)}:${time.substring(2,4)}:${time.substring(4)}`
      }
      return this.MaskTime(time)
    },

    save() {
      this.$validator.validateAll().then(async result => {
        if (!result) {
          showError(this.$t('campos-com-preenchimento-obrigatorio'));
          return;
        } 
        else 
        { 
          this.workshift.forEach(w => w.startTime = w.start)
          defaultSuccess(this.$t('salvando-dados'));
          
          axios.post(`${urlMainAPI}/saveworkshift/`, this.workshift)
            .then(res => {
              this.$nextTick(() => {
                this.$validator.reset();
              });
              defaultSuccess(this.$t('turnos-atualizados-com-sucesso'));
              this.setWorkShift(res, this.typeSetShift.shift)
            })
            .catch(() => {
              this.resetForm();
            });

          this.workshiftDay.forEach(w => w.startTime = w.start)  
          axios.post(`${urlMainAPI}/saveworkshift/`, this.workshiftDay)
            .then(res => {
              this.$nextTick(() => {
                this.$validator.reset();
              });
              defaultSuccess(this.$t('boletim-atualizado-com-sucesso'));
              this.setWorkShift(res, this.typeSetShift.day)
            })
            .catch(() => {
              this.resetForm();
            });
        }
      });
    },

    load(){
      const url = `${urlMainAPI}/getworkshift`
      axios
      .get(url)
      .then(res => {
        this.setWorkShift(res, this.typeSetShift.all)
        this.$nextTick(() => {
          this.$validator.reset();
        });
      })
    },

    async setWorkShift(res, typeSetShift) {
      if(res.data && res.data.length > 0){
        let works = res.data
        
        if(typeSetShift == "all"){
          this.processAllWorkshifts(works)
        }
        else if(typeSetShift == "day"){
          this.processDayWorkshifts(works)

        }else if(typeSetShift == "shift"){
          this.processShiftWorkshifts(works)
        }
          
      }else{
        this.init();
      }
    },

    processAllWorkshifts(works){
      this.processDayWorkshifts(works)
      this.processShiftWorkshifts(works)
    },

    processDayWorkshifts(works){
      let workshiftDayfilter = works.filter(shift => shift.id === 4);
      this.workshiftDay = this.generateNewWorkshift(workshiftDayfilter)
    },

    processShiftWorkshifts(works){
      this.backupWorkshift = new Array()
      this.sort(works)

      if(works.length > 3){
        works.pop();
      }

      this.backupWorkshift = this.copyfrom(works)
      this.workshift = this.copyfrom(works)
      this.sort(this.backupWorkshift)
      this.sort(this.workshift)
    },

    generateNewWorkshift(workshift) {
      let workshiftObj = [new WorkShift()]
      workshift.forEach((w, i) => {
        workshiftObj[i].id = w.id
        workshiftObj[i].description = w.description
        workshiftObj[i].end = w.end
        workshiftObj[i].start = w.start
        workshiftObj[i].reference = w.reference
      })
      return workshiftObj;
    },

    sort(w) {
      w.sort((a, b) => {
        if (a.id > b.id)
          return 1
        else if (a.id < b.id)
          return -1
        return 0
      })
    },

    copyfrom(from){
      let to = [new WorkShift(), new WorkShift(), new WorkShift()]
      from.forEach((w, i) => {
        to[i].id = w.id
        to[i].description = w.description
        to[i].end = w.end
        to[i].start = w.start
        to[i].reference = w.reference
      })

      return to;
    },

    setReference(shift){
      console.log('shift :>> ', shift);
      this.workshift.forEach(w => {
        if(w.id == shift.id)
          w.reference = 1
        else
          w.reference = 0
      })
    },

    resetForm() {      
      this.$nextTick(() => {
        this.$validator.reset();
      });
      this.reset();
      defaultSuccess(this.$t('formulario-restaurado')) 
    },

    init() {
      let shift = [new WorkShift(), new WorkShift(), new WorkShift()];
      shift[0].id = 1;
      shift[1].id = 2;
      shift[2].id = 3;

      shift[0].description = this.$t('turno-a');
      shift[1].description = this.$t('turno-b');
      shift[2].description = this.$t('turno-c');

      shift[0].start = "00:00:00";  
      shift[1].start = "08:00:00";
      shift[2].start = "16:00:00";

      shift[0].end = "07:59:59";
      shift[1].end = "15:59:59";
      shift[2].end = "23:59:59";

      shift[0].reference = 1;
      this.workshift = shift;
    },

    reset() {
      if(!this.backupWorkshift.length){
        this.init();
        return;
      }

      this.workshift[0].id = this.backupWorkshift[0].id;
      this.workshift[1].id = this.backupWorkshift[1].id;
      this.workshift[2].id = this.backupWorkshift[2].id;
      this.workshiftDay[0].id = this.backupWorkshift[3].id;

      this.workshift[0].description = this.backupWorkshift[0].description;
      this.workshift[1].description = this.backupWorkshift[1].description;
      this.workshift[2].description = this.backupWorkshift[2].description;
      this.workshiftDay[0].id = this.backupWorkshift[3].description;

      this.workshift[0].start = this.backupWorkshift[0].start;
      this.workshift[1].start = this.backupWorkshift[1].start;
      this.workshift[2].start = this.backupWorkshift[2].start 
      this.workshiftDay[0].id = this.backupWorkshift[3].start;

      this.workshift[0].end = this.backupWorkshift[0].end;
      this.workshift[1].end = this.backupWorkshift[1].end;
      this.workshift[2].end = this.backupWorkshift[2].end;
      this.workshiftDay[0].id = this.backupWorkshift[3].end;

      this.workshift[0].reference = this.backupWorkshift[0].reference;
      this.workshift[1].reference = this.backupWorkshift[1].reference;
      this.workshift[2].reference = this.backupWorkshift[2].reference;
      this.workshiftDay[0].id = this.backupWorkshift[3].reference;
    }
  }
};
</script>

<style scoped>
.main {
    min-width: 280px;
}

.card-body {
  margin: 0;
  padding: 0 15px 10px 15px;
}

.card-body .text-title{
  font-size: 20px;
  font-style: bold;  
  padding-top: 15px;
  padding-left: 20px;
}

.card-body .text-title-2{
  font-size: 20px;
  font-style: bold;  
  padding-left: 20px;
}

.row-card.title>div{
  text-align: center;
  height: 30px;
}

.row-card>div{
  padding: 0 7.5px;
  height: 45px;
}

.radio-reference>div{
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.radio-reference>div{
  margin: 0 0 0 20px;
  padding: 0;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.groupBtn img {
  cursor: pointer;
}

img {
  max-height: 35px;
}

.loading{
  text-align: center;
}

@media (max-width: 575px) { 
  .row-card {
    display: grid;
    grid-template-columns: 50% 50%;
    margin-top: 15px !important;
  }

  .col-phone-1{
    grid-column-start: 1;
  }

  .col-phone-2{
    grid-column-start: 2;
    grid-row-start: 2;
  }
}

</style>
